<style scoped>
.footer {
	font-size: 18px;
	color: #999999;
	text-align: center;
	line-height: 84px;
}

/*头像*/
.personageBox {
	height: 254px;
	/*background: pink;*/
	width: 230px;
	position: absolute;
	right: 10px;
	background: #F9F9F9;
	z-index: 6;
}

.personageBox ul {
	float: none;
	margin-left: 0;
}

.personageBox ul li {
	height: 84px;
	font-size: 20px;
	color: #999999;
	text-align: center;
	line-height: 84px;
	border-bottom: 1px solid #ECECEC;
	float: none;
}

.personageBox ul li:nth-of-type(3) {
	border: none;
}

.scodes img {
	width: 40px;
	height: 40px;
	border-radius: 50%;
	vertical-align: middle;
}

/*over*/
.my-trans-enter-active,
.my-trans-leave-active {
	transition: all .5s ease-out;
}

.my-trans-enter {
	transform: translateX(-200px);
	opacity: 0;
}

.my-trans-leave-active {
	transform: translateX(1000px);
}

.helpBox {
	/*width: 580px;*/
	/*height: 590px;*/
	position: fixed;
	z-index: 10;
	/*background: #FFFFFF;*/
	left: 72%;
	top: 50%;
	/*margin-left: -290px;*/
	margin-top: -295px;
}

html,
body {
	height: 100%;
	width: 100%;
}

#cower {
	height: 100%;
	width: 100%;
	background: rgba(0, 0, 0, 0.5);
	position: fixed;
	z-index: 6;
}

.tipBox {
	width: 580px;
	height: 592px;
	position: fixed;
	z-index: 10;
	background: #FFFFFF;
	left: 50%;
	top: 50%;
	margin-left: -290px;
	margin-top: -295px;
}

.tipBox h3 {
	width: 100%;
	text-align: center;
	padding: 40px 0 20px 0;
}

.tipBox p {
	font-size: 20px;
	color: #666666;
	text-align: center;
}

.tipBox p img {
	padding-top: 30px;
	width: 280px;
}

.tipBox h6 {
	font-size: 14px;
	padding-top: 20px;
	text-align: center;
}

.tipBox h6 a {
	color: #666666;
	font-weight: 400;
}

header {
	width: 1260px;
	height: 84px;
	margin: 0 auto;
	vertical-align: middle;
	padding-top: 20px;
	position: relative;
}

header img {
	width: 150px;
	height: 60px;
}

.logo {
	float: left;
}

header ul {
	float: left;
	margin-left: 120px;
}

header ul li {
	float: left;
	line-height: 60px;
	padding: 0 40px;
	font-size: 20px;
	color: #666666;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

header ul li:hover {
	color: #0075FC;
}

header ul li:nth-of-type(3) a {
	color: #0075FC;
}

.scodes {
	border-radius: 8px;
	width: 130px;
	height: 50px;
	display: inline-block;
	text-align: center;
	line-height: 50px;
	font-size: 20px;
	color: #FFFFFF;
	margin-left: 50px;
	background-image: linear-gradient(270deg, #FCA36A 0%, #EC5E45 98%);
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

aside {
	width: 100%;
	background: #0075FC;
	padding-top: 50px;
	min-height: 800px;
}

.content {
	height: 700px;
	width: 1260px;
	margin: 0 auto;
	/*border: 1px solid #EBEBEB;*/
}

.leftBox {
	width: 450px;
	height: 700px;
	/*background: red;*/
	float: left;
	position: relative;
	background: url(../assets/teamaboutme.png) no-repeat right;
	background-position: right 20px;
}

.leftBox img {
	width: 100%;
}

/*.leftBox p{
		font-size: 20px;
		color: #666666;
		letter-spacing: 0;
		line-height: 27px;
		padding: 20px 30px 0 30px;
	}*/
.leftBox .bg {
	position: absolute;
	left: 0;
	top: 0;
	width: 360px;
}

.leftBox .pic {
	position: absolute;
	left: 32px;
	width: 326px;
	height: 426px;
}

.picfix {
	position: absolute;
	bottom: 156px;
	width: 326px;
	left: 32px;
	height: 100px;
}

.picfix h5 {
	font-size: 24px;
	color: #3296FA;
	padding-left: 20px;
}

.picfix p {
	font-size: 20px;
	color: #2A2A2A;
	padding-left: 20px;
}

.rightBox {
	width: 760px;
	height: 700px;
	float: right;
	padding-top: 20px;
	position: relative;
	/*background: green;*/
}

.rightBox h3 {
	font-size: 24px;
	color: #FFFFFF;
	font-weight: 500;
	padding-bottom: 20px;
}

.jingliBox {

	width: 580px;
	height: 520px;
	/*opacity: 0.1;*/
	background: rgba(255, 255, 255, 0.1);
}

.jingliBox p {
	font-size: 14px;
	color: #FFFFFF;
	line-height: 37px;
	padding: 20px;
}

.files {
	position: absolute;
	right: 0;
	width: 160px;
	height: 560px;
	bottom: 85px;
}

.files ul li {
	font-size: 16px;
	color: #FFFFFF;
	padding-bottom: 130px;
	text-align: right;
}

.sss {
	position: absolute;
	right: 23px;
	width: 30px;
	height: 350px;
	bottom: 193px;
	border-right: 3px solid #FFFFFF;
}

.imgo {
	position: absolute;
	right: -11px;
	top: -14px;
}

.imgs {
	position: absolute;
	right: -9px;
	top: 160px;
}

.imgt {
	position: absolute;

	right: -9px;
	top: 342px;
}
</style>

<template>
	<div>
		<div id="cower" @click="codeHide()" v-show="iscode"></div>
		<div class="tipBox" v-show="iscode">
			<h3>
				<img src="../assets/logo.png" />
			</h3>
			<p>明医智APP扫描二维码进行登录</p>
			<p style="padding-top: 20px;">
				<qriously :value="initQCode" :size="300" />
			</p>
			<h6><a href="#">没有账号？立即下载</a></h6>
		</div>
		<transition name="my-trans">
			<div class="helpBox" v-show="show">
				<img src="../assets/help.png" />
			</div>
		</transition>

		<div class="headers" style="position: relative;">
			<header>
				<div class="logo">
					<img src="../assets/logo.png" />
				</div>
				<ul>
					<li><router-link to="/">产品介绍</router-link></li>
					<!-- <li><router-link to="/News">新闻动态</router-link></li> -->
					<li><router-link to="/aboutUs">关于我们</router-link></li>
					<li><router-link to="/introduce">团队介绍</router-link></li>
					<li><router-link to="/contact">联系我们</router-link></li>
				</ul>
				<span class="scodes" style="min-width: 136px;" @click="codeShow(); headerShow(); openselect()"
					v-bind:style="{ fontSize: myfont }"><img v-show="header"
						style="margin-right: 10px;vertical-align: super;" :src="userimg" /><i
						v-bind:style="{ width: iwidth }"
						style="display: inline-block;margin: 0 2px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap">{{
							loginTxt }}</i><img v-show="header"
						style="position: absolute;right: 10px;border-radius: 0;width: 7px;height: 7px;top: 42px;"
						src="../assets/385616900272080137.png" /></span>
				<div class="personageBox" v-show="isLogin">
					<ul>
						<router-link to="/uploadLive">
							<li>上传视频</li>
						</router-link>
						<router-link to="/openLive">
							<li>发起直播</li>
						</router-link>
						<li @click="loginOut()">退出</li>
					</ul>
				</div>
			</header>
		</div>
		<aside>
			<!--<img class="leftImg" src="../assets/4444.png"/>-->
			<div class="content">
				<div class="leftBox">
					<img class="bg" src="../assets/teamdoctorbg.png" />
					<img class="pic" :src="bossOneImg" />
					<div class="picfix">
						<h5>{{ bossOneJob }}</h5>
						<p><img style="width: 50px;" src="../assets/Rectangle 4.png" /></p>
						<p>{{ bossOneName }}</p>
					</div>
				</div>
				<div class="rightBox">
					<h3>个人经历</h3>
					<div class="jingliBox">
						<p v-html="bossOne"></p>
					</div>
					<div class="files">
						<ul style="position: absolute;right: 40px;">
							<li>
								{{ bossOneJob }}
								<p>{{ bossOneName }}</p>
							</li>
							<li>
								{{ bossTwoJob }}
								<p>{{ bossTwoName }}</p>
							</li>
							<li>
								{{ bossThreeJob }}
								<p>{{ bossThreeName }}</p>
							</li>
						</ul>
						<div class="sss">
							<p><img class="imgo" src="../assets/team_me_sel.png" /></p>
							<p><router-link to="/introduce2"><img class="imgs" src="../assets/team_me.png" /></router-link>
							</p>
							<p><router-link to="/introduce3"><img class="imgt" src="../assets/team_me.png" /></router-link>
							</p>
						</div>

					</div>
				</div>

			</div>

		</aside>
		<!-- <div class="fottors">
			<a style="font-size: 18px;color: #666666;text-align: center;"
				href="https://www.miitbeian.gov.cn">京ICP备18010429号</a>
		</div> -->
		<div class="footer">Copyright © 2020-06-12 eagle soar . All Rights Reserved. 京ICP备18010429号</div>
	</div>
</template>

<script>
export default {
	name: 'HelloWorld',
	data() {
		return {
			msg: 'Welcome to Your Vue.js App',
			iscode: false,
			show: false,
			isLogin: false,
			loginTxt: '扫码登陆',
			header: false,
			myfont: '20px',
			initQCode: '',
			iwidth: '90px',
			code: '',
			urltime: '',
			token: '',
			userimg: '',
			bossOne: '',
			bossOneName: '',
			bossOneJob: '',
			bossOneImg: '',
			bossTwoJob: '',
			bossTwoName: '',
			bossThreeJob: '',
			bossThreeName: ''
		}
	},
	created: function () {
		this.headerShow();
		this.getMsg();
		this.codeShow();
	},
	methods: {
		loginOut() {
			localStorage.clear();
			location.reload();
		},
		codeShow() {
			if (typeof localStorage.username != "undefined") {
				console.log(this.loginTxt)
				this.loginTxt = localStorage.username;
				this.userimg = localStorage.userimg;
				if (this.loginTxt != '扫码登陆') {
					this.myfont = '14px';
					this.iwidth = '55px';
					this.header = true;
					this.iscode = false;
					this.show = false;
					clearInterval(this.urltime);
					return
				} else {
					this.getCode();
					this.iwidth = '55px';
					this.isLogin = false;
					this.iscode = true;
					this.show = true;
					this.urltime = setInterval(() => {
						this.getLogin();
					}, 5000);
				}
			}
		},
		openselect() {
			if (this.loginTxt != '扫码登陆') {
				this.isLogin = !this.isLogin;
			} else {
				this.getCode();
				this.iwidth = '90px';
				this.isLogin = false;
				this.iscode = true;
				this.show = true;
				this.urltime = setInterval(() => {
					this.getLogin();
				}, 5000);
			}
		},
		headerShow() {
			if (this.loginTxt != '扫码登陆') {
				this.myfont = '14px';
				//this.isLogin=!this.isLogin;
				this.header = true;
			}
		},
		codeHide() {
			this.iscode = false;
			this.show = false;
			clearInterval(this.urltime);
		},
		getMsg() {
			let _this = this;
			//console.log(this.roomName);
			//return
			let qs = require('qs');
			let data = qs.stringify({
				"newId": this.newsid
			})
			this.$http.post('/system/aboutUS.do', data)
				.then(function (response) {
					console.log(response);
					if (response.status == 200) {
						_this.bossOne = response.data.systemBase.bossOne;
						_this.Trim(_this.bossOne);
						_this.bossOneImg = response.data.systemBase.bossOneImg;
						_this.bossOneJob = response.data.systemBase.bossOneJob;
						_this.bossOneName = response.data.systemBase.bossOneName;
						_this.bossTwoJob = response.data.systemBase.bossTwoJob;
						_this.bossTwoName = response.data.systemBase.bossTwoName;
						_this.bossThreeJob = response.data.systemBase.bossThreeJob;
						_this.bossThreeName = response.data.systemBase.bossThreeName;

						//			   		$(".leftBox").css("background",'url(' + response.data.data.systemNews[0].cover + ')');
						//console.log(123)
						//_this.msg=response.data.data.systemNews;

						//			   		_this.cover=response.data.data.cover;
						//console.log(_this.mseArr);
						//alert('上传成功');
						//location.reload();

					}
				})
				.catch(function (error) {
					console.log(error);
				});
		},
		Trim(str) {  //str表示要转换的字符串

			this.bossOne = str.replace(/rn/g, "<br/>");

		},
		getLogin() {
			console.log(11111)
			let _this = this;
			let qs = require('qs');
			let data = qs.stringify({
				"code": _this.code
			})
			this.$http.post("checkQRCode.do", data)
				.then(function (response) {
					console.log(response);
					if (response.status == 200) {
						if (response.data.data.token != '') {
							clearInterval(_this.urltime);
							_this.loginTxt = response.data.data.username;
							_this.userimg = response.data.data.img;
							localStorage.username = response.data.data.username;
							localStorage.userimg = response.data.data.img;
							localStorage.userid = response.data.data.userid;
							token = response.data.data.token;
							_this.codeShow();
						}
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		},
		getCode() {
			let _this = this;
			this.$http.get("getQR.do")
				.then(function (response) {
					console.log(response);
					if (response.status == 200) {
						_this.initQCode = response.data.data.code;
						_this.code = response.data.data.code.split("code=")[1].split("&")[0];
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		}
	},
}
</script>




// WEBPACK FOOTER //
// src/pages/introduce.vue